import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Buttons } from 'components';
import { Plus } from 'assets/icons';
import Tooltip from '@mui/material/Tooltip';
import { routes } from 'config';
import { isAiAssistantEnabled } from 'utils';
import { DashboardCalendar } from './DashboardCalendar';

import * as S from './DashboardHeader.styled';

export const DashboardHeader = memo(({ dateRangeName$, dateFrom$, dateTo$ }) => {
  const navigate = useNavigate();

  const goToManageCampaigns = useCallback(() => {
    const url = routes.list.find((route) => route.id === 'campaign').url;
    navigate(url);
  }, [navigate]);

  const goToCreateCampaign = useCallback(() => {
    const url = routes.list.find((route) => route.id === 'campaign/newCampaign_empty').url;
    navigate(url);
  }, [navigate]);

  const handleAiAssistantClick = useCallback(() => {
    if (window.AppnextChat && typeof window.AppnextChat.open === 'function') {
      window.AppnextChat.open();
      return;
    }

    const toggle = document.querySelector('.cai-widget-toggle');
    if (toggle) {
      toggle.style.setProperty('display', '', '');
      toggle.click();
      toggle.style.setProperty('display', 'none', 'important');
    }
  }, []);

  return (
    <S.Header>
      <S.Title>Dashboard</S.Title>
      <S.CalendarBox>
        <DashboardCalendar
          dateFrom$={dateFrom$}
          dateTo$={dateTo$}
          dateRangeName$={dateRangeName$}
        />
      </S.CalendarBox>
      <S.Box gap={16}>
        <Buttons.SecondaryNormal id='manageCampaign' onClick={goToManageCampaigns}>
          Manage Campaign
        </Buttons.SecondaryNormal>
        <S.CreateCampaignGroup>
          <Buttons.PrimaryNormal
            icon={<Plus />}
            id='createCampaign'
            onClick={goToCreateCampaign}
            style={
              isAiAssistantEnabled()
                ? { borderTopRightRadius: 0, borderBottomRightRadius: 0 }
                : undefined
            }
          >
            Create Campaign
          </Buttons.PrimaryNormal>
          {isAiAssistantEnabled() && (
            <Tooltip title='Start with AI Assistant' arrow placement='top'>
              <S.AiAssistantButton onClick={handleAiAssistantClick}>
                <AiLightningIcon />
              </S.AiAssistantButton>
            </Tooltip>
          )}
        </S.CreateCampaignGroup>
      </S.Box>
    </S.Header>
  );
});

DashboardHeader.displayName = 'DashboardHeader';

const AiLightningIcon = () => (
  <svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13 2L4.5 14H12L11 22L19.5 10H12L13 2Z'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='1'
      strokeLinejoin='round'
    />
  </svg>
);
